"use client";
import cn from "clsx";
import { useRouter, usePathname } from "@/navigation";
import { Code, Flex } from "@radix-ui/themes";
import { Button, FormInstance, Popover, TimePicker } from "antd";
import { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Debug } from "@/util/debug";
import { useTranslations } from "next-intl";
import { LayoutProps, TimerForm, TimerProps } from "../layoutType";
import Icon from "@/components/common/icon/icon";
import { runFormFunction } from "../input/inputFunction";
import { brewingTimer } from "../list/defaultType";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
const oneday = 86400000;
const onehour = 3600000;
const onemin = 60000;
const main_timer_str = "main_timer";
const remove_timers: string[] = ["main_timer", brewingTimer];
const diffString = (diff: Dayjs | undefined) => {
  if (diff) {
    const daystr = diff.valueOf() > oneday ? Math.floor(diff.valueOf() / oneday) + " - " : "";
    const a = dayjs(diff.valueOf() - dayjs().utcOffset() * onemin).format(diff.valueOf() > onehour ? "HH:mm:ss.SSS" : "mm:ss.SSS");
    return daystr + a.substring(0, a.length - 2);
  } else {
    return undefined;
  }
};
const changeTimpkerClass = (add: boolean, obj?: Element) => {
  const pikerEl = document.querySelectorAll(
    ".ant-picker.ant-picker-outlined:has(input.timer_pick), .rt-DataListValue:has(.ant-picker.ant-picker-outlined input.timer_pick) .with_pick",
  );
  const animationElClass = "ant-picker"; //"ant-btn";
  const animationClass: string[] = ["animate-rotate-x"]; //, "animate-infinite", "animate-duration-1000"];
  if (pikerEl) {
    pikerEl.forEach((item, index) => {
      if (add) {
        item.classList.add("now_timer_pick");
        if (item.classList.contains(animationElClass)) {
          animationClass.forEach((ac) => {
            item.classList.add(ac);
          });
        }
      } else {
        item.classList.remove("now_timer_pick");
        if (item.classList.contains(animationElClass)) {
          animationClass.forEach((ac) => {
            item.classList.remove(ac);
          });
        }
      }
    });
  }
};
export default function MainTimer({
  className,
  params,
  menuPosition,
}: {
  className?: string;
  params?: LayoutProps;
  menuPosition?: string;
}) {
  const t = useTranslations("timer");
  const [show, setShow] = useState<string | undefined>(undefined);
  const [diff, setDiff] = useState<String | undefined | null>(null);
  const [content, setContent] = useState<ReactNode>(<Button className="min-w-[10rem]"></Button>);
  const [open, setOpen] = useState(false);
  const prevOpen = useRef(false);
  const timer = useRef<NodeJS.Timeout>(null);
  const timers = useRef<Record<string, Dayjs>>({});
  const forms = useRef<Record<string, TimerForm>>({});

  const endTimer = useCallback((prop: TimerProps) => {
    const timerList = typeof prop.timer === "string" ? [prop.timer] : prop.timer;
    timerList.forEach((tempTimer) => {
      if (prop.start) {
        timers.current[tempTimer] = prop.start;
        if (prop.form) {
          forms.current[tempTimer] = prop.form;
          if (prop.form.chart && prop.form.formFunction) {
            runFormFunction(prop.form.formFunction, prop.form.chart, "setStartTime", prop.start);
          }
        }
        setShow(tempTimer);
      } else {
        if (forms.current[tempTimer]) {
          //타이머 종료시 행동
          if (forms.current[tempTimer].timers && forms.current[tempTimer].timers.length > 0) {
            const pikers = document.querySelectorAll("form.ant-form input.timer_pick");
            if (pikers && pikers.length > 0) {
              pikers.forEach((picker) => {
                if (forms.current[tempTimer].timers.includes(picker.id)) {
                  changeTimpkerClass(false, picker);
                  picker.classList.remove("timer_pick");
                }
              });
            }
            const lastTimer = forms.current[tempTimer].timers[forms.current[tempTimer].timers.length - 1];
            if (lastTimer) {
              const lastPiker = document.querySelector("form.ant-form input#" + lastTimer);
              if (lastPiker) {
                lastPiker.classList.add("timer_pick");

                changeTimpkerClass(true, lastPiker);

                setTimeout(() => {
                  changeTimpkerClass(false, lastPiker);
                  lastPiker.classList.remove("timer_pick");
                }, 3000);
              }
            }
          }

          const chart = forms.current[tempTimer].chart ?? undefined;
          const formFunction = forms.current[tempTimer].formFunction;
          const chartTimerClear = prop.chartTimerClear ?? true;
          Debug("forms timer false", chart, forms.current[tempTimer], prop.chartTimerClear);
          setTimeout(() => {
            if (chart && formFunction && chartTimerClear) {
              runFormFunction(formFunction, chart, "setStartTime", undefined);
            }
          }, 3000);
          delete forms.current[tempTimer];
        } else {
          Debug("forms is null", prop.timer, forms.current);
        }
        delete timers.current[tempTimer];
        setShow(undefined);
        if (tempTimer === main_timer_str) {
          window.localStorage.removeItem(main_timer_str);
        }
      }
    });
  }, []);

  useEffect(() => {
    const checkShows = () => {
      const keys = Object.keys(timers.current);
      if (keys.length > 0) {
        setShow(keys[0]);
      } else {
        if (timer.current) {
          clearInterval(timer.current);
        }
        setDiff(null);
      }
    };
    if (show && timers.current[show]) {
      if (timer.current) {
        clearInterval(timer.current);
      }
      setDiff(diffString(dayjs(dayjs().diff(timers.current[show]))));
      timer.current = setInterval(() => {
        if (timers.current[show]) {
          setDiff(() => {
            return diffString(dayjs(dayjs().diff(timers.current[show])));
          });
        } else {
          checkShows();
        }
      }, 100);
    } else {
      checkShows();
    }
  }, [show]);

  useEffect(() => {
    const str = diff?.substring(diff.length - 1, diff.length);
    if (open) {
      if (str == "0" || !prevOpen.current) {
        const keys = Object.keys(timers.current);
        if (keys.length > 0) {
          setContent(
            <Flex className="flex-col">
              {keys.map((key, index) => {
                const now = dayjs();
                const nowdiff = now.diff(timers.current[key]); // diff > 3600000
                return (
                  <Code
                    variant="soft"
                    key={key}
                    color="brown"
                    highContrast
                    className={cn(index ? "mt-3" : "", "min-w-[10rem] py-3 font-bold cursor-pointer text-center rounded-lg")}
                    onClick={
                      key == show
                        ? undefined
                        : () => {
                            setShow(key);
                          }
                    }
                  >
                    {/* <Button
                    key={key}
                    className={cn(index ? "mt-3" : "", "min-w-[10rem]")}
                    onClick={
                      key == show
                        ? undefined
                        : () => {
                            setShow(key);
                          }
                    }
                  > */}
                    {t(key) + " : " + dayjs(nowdiff - now.utcOffset() * onemin).format(nowdiff > onehour ? "HH:mm:ss" : "mm:ss")}
                    {/* </Button> */}
                  </Code>
                );
              })}
            </Flex>,
            // keys.length > 0 ? (
            // ) : undefined,
          );
          // } else if (!diff) {
          //   //setContent(undefined);
          // } else {
          //   //setContent("Open");
        }
        if (open !== prevOpen.current) prevOpen.current = open;
      }
    } else {
      if (str == "0" && open !== prevOpen.current) prevOpen.current = open;
    }
    if (str == "0") {
      const formskeys = Object.keys(forms.current);
      if (formskeys.length > 0) {
        const offset = dayjs().utcOffset() * onemin;
        const now = dayjs();
        formskeys.forEach((item) => {
          const formTimers = forms.current[item].timers;
          const form = forms.current[item].form;
          const diff = now.valueOf() - timers.current[item].valueOf();
          if (formTimers && formTimers.length > 0) {
            let checkTimer: string | undefined = undefined;
            for (let i = 0; i < formTimers.length; i++) {
              const timerValue = form?.getFieldValue(formTimers[i]);
              if (timerValue !== null && timerValue !== undefined) {
                if (dayjs(timerValue).add(offset).valueOf() > diff) {
                  break;
                } else if (i == formTimers.length - 1 && dayjs(timerValue).add(offset).valueOf() < diff) {
                  Debug("over run");
                  checkTimer = undefined;
                  endTimer({ timer: item, start: undefined });
                  break;
                }
                checkTimer = formTimers[i];
              }
            }

            if (checkTimer) {
              const piker = document.querySelector("form.ant-form input#" + checkTimer);
              if (piker) {
                if (!piker.classList.contains("timer_pick")) {
                  const checks = document.querySelectorAll("form.ant-form input.timer_pick");
                  checks.forEach((check) => {
                    if (formTimers.includes(check.id)) {
                      changeTimpkerClass(false, check);
                      check.classList.remove("timer_pick");
                    }
                  });
                  piker.classList.add("timer_pick");
                  changeTimpkerClass(true, piker);
                }
              } else {
                // Debug("picker is null", piker, checkTimer);
              }
            } else {
              // Debug("checkTimer is null", checkTimer, formTimers, form, item, forms.current, forms.current[item]);
            }
          } else {
            // Debug("form timer is null", forms.current[item]);
          }
        });
      }
    }
  }, [diff, show, t, open, endTimer]);

  useEffect(() => {
    const main_timer: string = (window.localStorage.getItem(main_timer_str) ?? "").trim();
    if (main_timer) {
      const main_timer_dayjs = dayjs(main_timer);
      if (dayjs().diff(main_timer_dayjs) < oneday) {
        timers.current[main_timer_str] = dayjs(main_timer);
        setShow(main_timer_str);
      } else {
        window.localStorage.removeItem(main_timer_str);
      }
    }
    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, []);

  if (params != null) {
    params.setTimer = endTimer;
  }

  return (
    <Flex
      className={cn(
        className,
        "text-center text-lg my-1 items-center mt-[2px]",
        show
          ? menuPosition === "B"
            ? "timer-show sticky rounded-xl mr-2"
            : "timer-show fixed bottom-3 rounded-xl mr-4 md:mr-6"
          : "rt-r-fd-column ",
      )}
    >
      <Popover
        content={content}
        open={Object.keys(timers.current).length > 0 ? undefined : false}
        onOpenChange={(e) => {
          setOpen(e);
        }}
      >
        <Code variant="ghost" className={cn(show ? "" : "hidden", "my-1 ml-3 py-1 px-2 font-bold cursor-pointer whitespace-nowrap")}>
          {(show ? t(show) + " " : "") + (show && diff ? diff : "00:00.0")}
        </Code>
      </Popover>
      <Button
        type="text"
        className="group"
        icon={
          <Icon
            iconName="Clock"
            iconType=""
            className={cn(show ? "animate-pulse" : "group-hover:animate-wiggle-more", "animate-infinite animate-duration-1000 w-5 h-5")}
          />
        }
        onClick={(e: any) => {
          if (show && remove_timers.includes(show)) {
            endTimer({ timer: show, start: undefined });
          } else if (timers.current[main_timer_str]) {
            endTimer({ timer: main_timer_str, start: undefined });
          } else {
            const now = dayjs();
            window.localStorage.setItem(main_timer_str, now.format());
            timers.current[main_timer_str] = now;
            setShow(main_timer_str);
          }
        }}
      />
    </Flex>
  );
}
